"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOfbtWithdrawSchema = void 0;
const yup = __importStar(require("yup"));
const helpers_1 = require("@/helpers");
const createOfbtWithdrawSchema = ({ translationKeys, selectedCurrency, limits, tradingAccountCurrencyCode, propsToReplacePara1, initialValue, fields, customerType, showKatakanaFields, }) => {
    var _a, _b;
    const min = Number((limits === null || limits === void 0 ? void 0 : limits.limits) && ((_a = limits === null || limits === void 0 ? void 0 : limits.limits[tradingAccountCurrencyCode]) === null || _a === void 0 ? void 0 : _a.min));
    const max = Number((limits === null || limits === void 0 ? void 0 : limits.limits) && ((_b = limits === null || limits === void 0 ? void 0 : limits.limits[tradingAccountCurrencyCode]) === null || _b === void 0 ? void 0 : _b.max));
    /**
     * @todo
     * Refactor this and make it abstracted that the .shape and conditional validations are defined in PHP instead of hardcoding it here
     */
    return yup.object().shape({
        countryCode: yup.string()
            .required(translationKeys.validationWithdrawCountryCodeRequired),
        bank: yup.string()
            .required(translationKeys.validationWithdrawBankRequired),
        ifscCode: yup.string()
            .when("bank", {
            is: () => selectedCurrency === "inr",
            then: (schema) => schema.required(translationKeys.validationWithdrawIfscRequired)
        }),
        bankNameOther: yup.string()
            .nullable()
            .when("bank", {
            is: (input) => {
                return selectedCurrency === "jpy" && input === "other";
            },
            then: (schema) => schema.required(translationKeys.validationWithdrawOtherBankRequired)
        }),
        bankCode: yup.string()
            .when("bank", {
            is: () => selectedCurrency === "jpy",
            then: (schema) => schema
                .required(translationKeys.validationWithdrawBankCodeRequired)
                .numeric(translationKeys.validationWithdrawBankCodeTypeError)
        }),
        bankBranch: yup.string()
            .when("bank", {
            is: () => selectedCurrency === "jpy",
            then: (schema) => schema.required(translationKeys.validationWithdrawBankBranchRequired)
        }),
        branchCode: yup.string()
            .when("bank", {
            is: () => selectedCurrency === "jpy"
                || (selectedCurrency === "jpy" && fields && fields.some((f) => f.name === 'branchCode' && !(f === null || f === void 0 ? void 0 : f.hidden))),
            then: (schema) => schema.required(translationKeys.validationWithdrawBranchCodeRequired)
                .numeric(translationKeys.validationAccountNumberNumeric)
                .numberLength(3, 3, translationKeys.validationWithdrawBranchCodeLength)
        }),
        accountType: yup.string()
            .when("bank", {
            is: () => selectedCurrency === "jpy",
            then: (schema) => schema.required(translationKeys.validationWithdrawAccountTypeRequired)
        }),
        userAccountName: yup.string(),
        katakanaFirstName: yup.string()
            .when("bank", {
            is: () => showKatakanaFields && customerType == "trader_type_individual",
            then: (schema) => schema
                .required(translationKeys.validationWithdrawKatakanaGiveNameRequired)
                .katakana(translationKeys.validationWithdrawKatakanaCharacters)
                .max(20, translationKeys.validationWithdrawKatakanaMax),
        }),
        katakanaLastName: yup.string()
            .when("bank", {
            is: () => showKatakanaFields && customerType == "trader_type_individual",
            then: (schema) => schema
                .required(translationKeys.validationWithdrawKatakanaFamilyNameRequired)
                .katakana(translationKeys.validationWithdrawKatakanaCharacters)
                .max(20, translationKeys.validationWithdrawKatakanaMax),
        }),
        accountNumber: yup.string()
            .numeric(translationKeys.validationAccountNumberNumeric)
            .required(translationKeys.validationWithdrawAccountNumberRequired)
            .when("bank", {
            is: () => selectedCurrency === "jpy",
            then: (schema) => schema.numberLength(7, 7, translationKeys.accountNumberLengthValidation)
        }),
        accountNickname: yup.string(),
        amount: yup.number()
            .transform((currentValue, originalValue) => Number((0, helpers_1.removeThousandSeparator)(originalValue)))
            .required(translationKeys.validationWithdrawAmountRequired)
            .typeError(translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys.request_amount_invalid_type)
            .minMaxLimit(min, max, (0, helpers_1.withDynamicTranslation)(translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys.validationWithdrawAmountMax, propsToReplacePara1), initialValue)
    });
};
exports.createOfbtWithdrawSchema = createOfbtWithdrawSchema;
